export const mockRestaurant = {
    restaurant: {
        id: "12345",
        name: "S3c Demo Dine",
        description: "Where culinary art meets exceptional taste. Experience our world-class menu.",
        address: "123 Gourmet Ave, Food City",
        phoneNumber: "+1 (555) 019-2834",
        email: "reservations@s3cfinedine.com",
        backgroundImageUrl: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?fit=crop&w=1920&q=80",
        logoUrl: "",
        tagline: "Heritage Gastronomy • Fresh • Organic • Local",
        footerText: "Made with Love • Served with Pride • Thank you for choosing us!",
        establishedYear: "1968"
    },
    menus: [
        {
            id: "menu-main",
            name: "Main Menu",
            description: "A collection of our finest dishes.",
            categories: [
                {
                    id: "cat-starters",
                    name: "Starters",
                    displayOrder: 1,
                    items: [
                        {
                            id: "i-s1",
                            name: "Truffle Arancini",
                            description: "Crispy risotto balls infused with black truffle oil, served with marinara dip.",
                            price: 12.00,
                            isVeg: true,
                            imageUrl: "https://images.unsplash.com/photo-1541529086526-db283c563270?fit=crop&w=500&q=80",
                            isAvailable: true,
                            variants: [],
                            tags: ["Vegetarian", "Popular"]
                        },
                        {
                            id: "i-s2",
                            name: "Bruschetta Trio",
                            description: "Classic tomato basil, mushroom truffle, and ricotta honey walnut on toasted sourdough.",
                            price: 10.50,
                            isVeg: true,
                            imageUrl: "https://images.unsplash.com/photo-1572695157369-24d29ca1653d?fit=crop&w=500&q=80",
                            isAvailable: true,
                            variants: [],
                            tags: ["Vegetarian"]
                        },
                        {
                            id: "i-s3",
                            name: "Spicy Calamari",
                            description: "Fried calamari rings tossed in chili garlic sauce.",
                            price: 14.00,
                            isVeg: false,
                            imageUrl: "https://images.unsplash.com/photo-1604909052743-94e838986d24?fit=crop&w=500&q=80",
                            isAvailable: true,
                            variants: [
                                { id: "v-s3-1", name: "Mild", price: 0, isActive: true },
                                { id: "v-s3-2", name: "Extra Spicy", price: 0.50, isActive: true }
                            ],
                            tags: ["Spicy", "Chef's Special"]
                        }
                    ]
                },
                {
                    id: "cat-mains",
                    name: "Mains",
                    displayOrder: 2,
                    items: [
                        {
                            id: "i-m1",
                            name: "Grilled Salmon",
                            description: "Atlantic salmon fillet with asparagus and lemon butter sauce.",
                            price: 0.00,
                            isVeg: false,
                            imageUrl: "https://images.unsplash.com/photo-1467003909585-6f8c7710d58b?fit=crop&w=500&q=80",
                            isAvailable: true,
                            variants: [],
                            tags: ["Healthy", "Gluten-Free"]
                        },
                        {
                            id: "i-m2",
                            name: "Ribeye Steak",
                            description: "12oz grass-fed ribeye, grilled to your liking.",
                            price: 32.00,
                            isVeg: false,
                            imageUrl: "https://images.unsplash.com/photo-1546964124-0cce460f38ef?fit=crop&w=500&q=80",
                            isAvailable: true,
                            variants: [
                                { id: "v-r1", name: "Rare", price: 0, isActive: true },
                                { id: "v-r2", name: "Medium Rare", price: 0, isActive: true },
                                { id: "v-r3", name: "Well Done", price: 0, isActive: true }
                            ],
                            tags: ["Gluten-Free", "Popular"]
                        },
                        {
                            id: "i-m3",
                            name: "Wild Mushroom Risotto",
                            description: "Creamy arborio rice with porcini mushrooms and parmesan crisp.",
                            price: 19.50,
                            isVeg: true,
                            imageUrl: "https://images.unsplash.com/photo-1476124369491-e7addf5db371?fit=crop&w=500&q=80",
                            isAvailable: true,
                            variants: [],
                            tags: ["Vegetarian", "Gluten-Free"]
                        },
                        {
                            id: "i-m4",
                            name: "Chicken Parmesan",
                            description: "Breaded chicken breast topped with marinara and melted mozzarella.",
                            price: 21.00,
                            isVeg: false,
                            imageUrl: "https://images.unsplash.com/photo-1632778149955-e80f8ceca2e8?fit=crop&w=500&q=80",
                            isAvailable: true,
                            variants: [],
                            tags: ["Popular"]
                        }
                    ]
                },
                {
                    id: "cat-desserts",
                    name: "Desserts",
                    displayOrder: 3,
                    items: [
                        {
                            id: "i-d1",
                            name: "Tiramisu",
                            description: "Classic Italian dessert with mascarpone and espresso-soaked ladyfingers.",
                            price: 9.00,
                            isVeg: true,
                            imageUrl: "https://images.unsplash.com/photo-1571877227200-a0d98ea607e9?fit=crop&w=500&q=80",
                            isAvailable: true,
                            variants: [],
                            tags: ["Vegetarian"]
                        },
                        {
                            id: "i-d2",
                            name: "Molten Lava Cake",
                            description: "Warm chocolate cake with a gooey center, served with vanilla ice cream.",
                            price: 11.00,
                            isVeg: true,
                            imageUrl: "https://images.unsplash.com/photo-1624353365286-3f8d62daad51?fit=crop&w=500&q=80",
                            isAvailable: true,
                            variants: [],
                            tags: ["Vegetarian", "New"]
                        }
                    ]
                },
                {
                    id: "cat-drinks",
                    name: "Drinks",
                    displayOrder: 4,
                    items: [
                        {
                            id: "i-dr1",
                            name: "Fresh Lemonade",
                            description: "Squeezed fresh daily.",
                            price: 4.50,
                            isVeg: true,
                            imageUrl: "https://images.unsplash.com/photo-1513558161293-cdaf765ed2fd?fit=crop&w=500&q=80",
                            isAvailable: true,
                            variants: [
                                { id: "v-dr1", name: "Regular", price: 0, isActive: true },
                                { id: "v-dr2", name: "Large", price: 1.50, isActive: true },
                                { id: "v-dr3", name: "Small", price: 1.50, isActive: true },
                                { id: "v-dr4", name: "Extra Small", price: 1.00, isActive: true },
                                { id: "v-dr5", name: "Extra Large", price: 1.50, isActive: true }
                            ],
                            tags: ["Vegan", "Gluten-Free"]
                        },
                        {
                            id: "i-dr2",
                            name: "Mojito",
                            description: "Classic mint and lime cocktail (Alcoholic).",
                            price: 12.00,
                            isVeg: true,
                            imageUrl: "https://images.unsplash.com/photo-1551538827-9c037cb4f32a?fit=crop&w=500&q=80",
                            isAvailable: true,
                            variants: [],
                            tags: ["Vegan", "Gluten-Free"]
                        }
                    ]
                }
            ],
            uncategorizedItems: []
        },
        {
            id: "menu-happy-hour",
            name: "Happy Hour",
            description: "Special pricing on drinks and bites. Mon-Fri 4pm-7pm.",
            categories: [
                {
                    id: "cat-hh-drinks",
                    name: "Happy Hour Drinks",
                    displayOrder: 1,
                    items: [
                        {
                            id: "i-hh-1",
                            name: "House Margaritas",
                            description: "Classic lime margarita on the rocks.",
                            price: 6.00,
                            isVeg: true,
                            imageUrl: "https://images.unsplash.com/photo-1556679343-c7306c1976bc?fit=crop&w=500&q=80",
                            isAvailable: true,
                            variants: [],
                            tags: ["Vegan", "Gluten-Free", "Popular"]
                        },
                        {
                            id: "i-hh-2",
                            name: "Draft Beers",
                            description: "Select local craft beers on tap.",
                            price: 5.00,
                            isVeg: true,
                            imageUrl: "https://images.unsplash.com/photo-1535958636474-b021ee8816a3?fit=crop&w=500&q=80",
                            isAvailable: true,
                            variants: [],
                            tags: []
                        }
                    ]
                },
                {
                    id: "cat-hh-bites",
                    name: "Bar Bites",
                    displayOrder: 2,
                    items: [
                        {
                            id: "i-hh-3",
                            name: "Loaded Nachos",
                            description: "Tortilla chips topped with cheese, jalapenos, and salsa.",
                            price: 8.00,
                            isVeg: true,
                            imageUrl: "https://images.unsplash.com/photo-1513456852971-30c0b8199d4d?fit=crop&w=500&q=80",
                            isAvailable: true,
                            variants: [],
                            tags: ["Vegetarian", "Spicy"]
                        },
                        {
                            id: "i-hh-4",
                            name: "Mini Sliders",
                            description: "Two beef sliders with american cheese.",
                            price: 9.00,
                            isVeg: false,
                            imageUrl: "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?fit=crop&w=500&q=80",
                            isAvailable: true,
                            variants: [],
                            tags: []
                        }
                    ]
                }
            ],
            uncategorizedItems: []
        },
        {
            id: "menu-brunch",
            name: "Weekend Brunch",
            description: "Sat-Sun 10am-2pm. The best way to start your weekend.",
            categories: [
                {
                    id: "cat-brunch-1",
                    name: "Morning Classics",
                    displayOrder: 1,
                    items: [
                        {
                            id: "i-br-1",
                            name: "Avocado Toast",
                            description: "Sourdough toast topped with smashed avocado, poached egg, and chili flakes.",
                            price: 13.50,
                            isVeg: true,
                            imageUrl: "https://images.unsplash.com/photo-1525351484163-7529414395d8?fit=crop&w=500&q=80",
                            isAvailable: true,
                            variants: [],
                            tags: ["Vegetarian", "Healthy"]
                        },
                        {
                            id: "i-br-2",
                            name: "Buttermilk Pancakes",
                            description: "Stack of fluffy pancakes with maple syrup and berries.",
                            price: 11.00,
                            isVeg: true,
                            imageUrl: "https://images.unsplash.com/photo-1506084868230-bb9d95c24759?fit=crop&w=500&q=80",
                            isAvailable: true,
                            variants: [
                                { id: "v-br-1", name: "Banana Nut", price: 2.00, isActive: true },
                                { id: "v-br-2", name: "Plain", price: 0.00, isActive: true }
                            ],
                            tags: ["Vegetarian"]
                        }
                    ]
                },
                {
                    id: "cat-brunch-2",
                    name: "Brunch Cocktails",
                    displayOrder: 2,
                    items: [
                        {
                            id: "i-br-3",
                            name: "Mimosa",
                            description: "Prosecco and fresh orange juice.",
                            price: 8.00,
                            imageUrl: "https://images.unsplash.com/photo-1543094894-39f4e2f9d863?fit=crop&w=500&q=80",
                            isAvailable: true,
                            variants: [],
                            tags: ["Popular"]
                        }
                    ]
                }
            ],
            uncategorizedItems: []
        }
    ]
    ,
    offers: [
        {
            id: "67944151-1ed8-4c0b-95a9-b786bda2d614",
            restaurantId: "12345",
            title: "Welcome Notes",
            description: "Welcome to S3c Demo Dine. Images are for presentation; actual items may vary.",
            type: { name: "Notes", value: 5, displayName: "Notes" },
            startDate: "2026-03-21T00:00:00Z",
            endDate: "2026-04-01T00:00:00Z",
            isActive: true,
            isExpired: false,
            createdDate: "2026-03-21T10:00:00Z",
            modifiedDate: "2026-03-21T10:00:00Z"
        },
        {
            id: "bfea1e04-fc04-42e8-b63a-a4e3c45c91f6",
            restaurantId: "12345",
            title: "Get 2 for the price of 1",
            description: "Buy one Ham burger and get one free for your partner",
            type: { name: "Combos", value: 2, displayName: "Combos" },
            startDate: "2026-03-21T00:00:00Z",
            endDate: "2026-03-31T00:00:00Z",
            isActive: true,
            isExpired: false,
            createdDate: "2026-03-21T09:23:46Z",
            modifiedDate: "2026-03-21T09:23:46Z"
        },
        {
            id: "87ddd872-2391-40fe-a60a-a5259fd0d305",
            restaurantId: "12345",
            title: "Flat 20% Off",
            description: "Flat 20% off on Desserts this week",
            type: { name: "Deals", value: 1, displayName: "Deals" },
            startDate: "2026-03-11T00:00:00Z",
            endDate: "2026-03-22T00:00:00Z",
            isActive: true,
            isExpired: false,
            createdDate: "2026-03-09T04:13:54Z",
            modifiedDate: "2026-03-09T04:13:54Z"
        }
    ]
};

// Map shortcodes to specific templates for testing
export const mockResolvers = {
    'test': { resolvedUrl: '...', templateName: 'Classic Elegance' },
    'chic': { resolvedUrl: '...', templateName: 'Modern Chic' },
    'luxe': { resolvedUrl: '...', templateName: 'Midnight Luxe' },
    'dsc': { resolvedUrl: '...', templateName: 'DineStack Classic' },
    'explorer': { resolvedUrl: '...', templateName: 'Menu Explorer' },
    'classic-print': { resolvedUrl: '...', templateName: 'Classic Print' },
    'modern-minimalist': { resolvedUrl: '...', templateName: 'Modern Minimalist' },
    'royal-gold': { resolvedUrl: '...', templateName: 'Royal Gold' },
    'garden-fresh': { resolvedUrl: '...', templateName: 'Garden Fresh' },
    'rustic-wood': { resolvedUrl: '...', templateName: 'Rustic Wood' },
    'urban-pop': { resolvedUrl: '...', templateName: 'Urban Pop' },
    'neon': { resolvedUrl: '...', templateName: 'Neon Nectar' },
    'boho': { resolvedUrl: '...', templateName: 'Boho Bliss' },
    'comic': { resolvedUrl: '...', templateName: 'Comic Crunch' },
    'cosmic': { resolvedUrl: '...', templateName: 'Cosmic Cantina' },
    'goan-fiesta': { resolvedUrl: '...', templateName: 'Goan Fiesta' },
    'azure-azulejos': { resolvedUrl: '...', templateName: 'Azure Azulejos' },
    'tropical-spice': { resolvedUrl: '...', templateName: 'Tropical Spice' },
};

export const getMockResolve = (shortcode) => {
    return mockResolvers[shortcode] || mockResolvers['test'];
};
